var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgShape2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.0763 2.73448L22.9972 1V11.4298L11.0763 11.5241V2.73448ZM9.99074 2.89413L1 4.11481L1.00837 11.5907L9.99467 11.5396L9.99074 2.89413ZM9.99343 21.1891L9.98645 12.5359L1.0066 12.478L1.0071 19.9574L9.99343 21.1891ZM22.9972 23L23 12.6172L11.0596 12.5978L11.0763 21.3227L22.9972 23Z",
    fill: "#B76E00"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgShape2);
export default __webpack_public_path__ + "static/media/shape2.a48b87b38318d736d17804124c29d907.svg";
export { ForwardRef as ReactComponent };